/**
 * 字級階梯。
 *
 * 這五個值全部是 antd 4.19.5 的原生值 (node_modules/antd/lib/style/themes/
 * default.less)，不是另立一套：
 *
 *   caption  = @font-size-sm    12px
 *   body     = @font-size-base  14px
 *   subtitle = @font-size-lg    16px
 *   title    = h4 = ceil(14 * 1.42)  20px
 *   display  = h2 = ceil(14 * 2.14)  30px
 *
 * 專案原本用 9 個手挑的數字 (9 / 10 / 11 / 11.5 / 12 / 12.5 / 13 / 13.5 / 15)
 * 疊出一條連續帶，相鄰只差 0.5～1px —— 肉眼分不出層級，卻把最小的一端拖到
 * 11px。這裡收斂成級距 ≥ 2px 的五級。
 *
 * body 通常不需要寫：不寫 fontSize 就是 antd 的 14px 預設。只有在要把某段文字
 * 從較小的父層拉回內文大小時才用得到 FONT.body。
 */
export const FONT = {
  caption: 12,
  body: 14,
  subtitle: 16,
  title: 20,
  display: 30,
};

export default FONT;
